import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Homepage from './Homepage';
import Gallery from './Gallery';
import About from './About';
import Contact from './Contact';
import Booking from './Booking';
import { Helmet } from 'react-helmet';
import Questions from './Questions';
import Reviews from './Reviews';
import Loader from './Loader';
import Blog from './Blog';
import BlogPost from './BlogPost';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path='/gallery' element= {<Gallery />} />
        <Route path='/about' element= {<About />} />
        <Route path= '/contact' element = {<Contact />} />
        <Route path='/booking' element = {<Booking />} />
        <Route path='/questions' element={<Questions />} />
        <Route path='/reviews' element= {<Reviews />} />
        <Route path='/loader' element= {<Loader />} />
        <Route path='/blog' element= {<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </>
  );
}

export default App;